'use strict';

var $d = require('../dependency');
var _ = $d._;
var apiRequest = $d.apiRequest;

exports.fetchChartData = fetchChartData;

/**
 * [fetchChartData plugin function to make API call for the chart data as a plugin.]
 * @param  {} context                   [the base config for the API call.]
 * @param  {array} queryParamObject    [the query object for the POST HTTP Data]
 * @param  {function} resolve          [function callback to pass the success object]
 * @param  {function} reject           [function callback to pass the failure object]
 * @return {undefined}
 */
function fetchChartData(context, config, next) {
    var ajaxPromise, ajaxObjectList = _.map(
      context.queryObjectList,
      function (queryObject) {
          ajaxPromise = apiRequest({
              url: context.apiPath,
              data: JSON.stringify(queryObject),
              dataType: 'json',
              type: 'POST',
              contentType: 'application/json',
              cid: context.cid,
              _otherInfo: context.otherInfo
          });
          return ajaxPromise;
      }
    );

    Promise.all(ajaxObjectList).then(
      function (args) {
          /* !ToDo resolve array */
          context.apiResponse = args;
          next();
      },
      function (err) {
          /* !ToDo reject array */
          err.isApiError = true;
          next(err);
      }
    );
}